import React from 'react';

import { Box } from '@mui/material';

import { useSetScrollTarget } from './scroll-context';

const PageContent = ({
  children,
  flexColumn = false,
  pagePadding = false,
  disableScroll = false,
  sx
}) => {
  // Can be called on any DOM node that the header uses to collapse
  const setScrollTarget = useSetScrollTarget();

  return (
    <Box
      ref={el => setScrollTarget(el || window)}
      sx={[
        {
          flex: 1,
          overflowY: disableScroll ? 'hidden' : 'auto'
        },
        flexColumn && { display: 'flex', flexDirection: 'column' },
        pagePadding && { px: 2, pb: 2 },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
    >
      {children}
    </Box>
  );
};

export default PageContent;
